import { HTTP } from "@/common/http-common";
const RESOURCE_NAME = "/virtual-classroom/lectures";

export default {
  async getAllToAttend(past) {
    const response = await HTTP.get(`${RESOURCE_NAME}?past=${past}`);
    return response.data;
  },
};
